<sb-card>
  <div card-header>
    <h3>{{ 'lang.globals.overview' | translate }}</h3>
  </div>
  <div card-body>
    <div class="row">
      <div class="col-4">
        <div class="flex-grow-1 w-100">
          <div class="d-flex align-items-center w-100 ">
            <div>
              <h4>{{ location?.name ? location?.name : location?.identifier }}</h4>
              <h6>{{ 'lang.globals.locationId' | translate }}: {{ location?.id }}</h6>
              <h6><span class="text-dark-75 font-weight-bolder"> {{ 'lang.globals.company:' | translate }} </span><a
                [innerHTML]="location?.managedBy?.name | truncate: 25"
                [pathParams]="[{id: 'companyID', value: location?.managedBy?.id}]"
                [sbRouterLink]="util.RoutingID.companyDetailsOverview"
                class="text-muted link"></a></h6>
            </div>
          </div>
          <div class="mt-4">
            <h5 class="mb-2">{{ 'lang.address.information:' | translate }}</h5>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{ 'lang.globals.street:' | translate }}</span><span
              class="text-muted"> {{ location?.address?.street }} {{ location?.address?.street2 }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">
                {{ 'lang.globals.zip:' | translate }}/ {{ 'lang.globals.city:' | translate }}
              </span>
              <span class="text-muted">
                {{ location?.address?.zip }}  {{ location?.address?.city }}
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{ 'lang.globals.state:' | translate }}</span><span
              class="text-muted"> {{ location?.address?.state }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{ 'lang.globals.country:' | translate }}</span><span
              class="text-muted"> {{ location?.address?.country }}</span>
            </div>
          </div>
          <div class="mt-4">
            <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
              <h5 class="">{{ 'lang.globals.openingHours:' | translate }}</h5>
              @if (permissionService.hasPermission(permissionService.Permission.weekly_schedule_list) && permissionService.hasPermission(permissionService.Permission.location_edit)) {

                <div class="tw-flex tw-gap-2">
                  <button sb-button-secondary [color]="'blue'" [iconButton]="true" [icon]="'selection'"
                          (click)="selectOpeningHours()"></button>
                  <button sb-button-secondary [color]="'red'" [iconButton]="true" [icon]="'trash'" [disabled]="!location?.serviceHours"
                          (click)="deleteOpeningHours()"></button>
                </div>
              }
            </div>
            <!-- TODO Maybe replace with weeklyScheduleComponent / update weeklyScheduleComponent with following -->
            <span *ngIf="!location?.serviceHours" class="text-dark-75 font-weight-bolder">{{ 'lang.globals.nA' | translate }}</span>
            <div *ngIf="location?.serviceHours" class="">
              <div *ngFor="let dayKey of weeklyScheduleService.dayKeys; let i = index;" class="mt-1">
                <div class="row m-0 align-items-baseline">
                  <div class="col-4 pl-0">
                    <span class="day-label">{{ 'lang.globals.weekday.' + dayKey | translate }}</span>
                  </div>
                  <div class="col-8" *ngIf="!location?.serviceHours[dayKey]">
                    <span style="font-style: italic;" class="tw-opacity-50">{{ 'lang.weeklySchedule.noRanges'| translate }}</span>
                  </div>
                  <div class="col-8" *ngIf="location?.serviceHours[dayKey]">
                    <div class="d-flex align-items-center mt-1"
                         *ngFor="let hourRange of location?.serviceHours[dayKey]?.intervals;">
                      <div>{{ getTimeString(hourRange, 'from') }}
                      </div>
                      <span class="separator"></span>
                      <div>{{ getTimeString(hourRange, 'till') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8">
        <sb-map [drawing]="false" [mapHeight]="470"
                [showSinglePoint]="getSelectedLocationCoords()"></sb-map>
      </div>
    </div>
  </div>
</sb-card>
